import "./ProductHeroShowcase.css";

export function ProductHeroShowcase({ copy }) {
  return (
    <aside className="product-hero-showcase" aria-label={copy.ariaLabel}>
      <article className="product-hero-card product-hero-card-primary">
        <div className="product-hero-card-head">
          <div>
            <p className="product-hero-kicker">{copy.snapshotKicker}</p>
            <h2 className="product-hero-title">{copy.snapshotTitle}</h2>
          </div>
          <span className="product-hero-status">{copy.snapshotStatus}</span>
        </div>

        <div className="product-hero-plan-list">
          {copy.planItems.map((item) => (
            <article key={item.title} className="product-hero-plan-item">
              <span className="product-hero-plan-mark" aria-hidden />
              <div className="product-hero-plan-copy">
                <div className="product-hero-plan-head">
                  <h3>{item.title}</h3>
                  <span className="product-hero-plan-badge">{item.badge}</span>
                </div>
                <p>{item.body}</p>
              </div>
            </article>
          ))}
        </div>

        {copy.signalChips?.length ? (
          <div className="product-hero-chip-row">
            {copy.signalChips.map((item) => (
              <span key={item} className="product-hero-chip">
                {item}
              </span>
            ))}
          </div>
        ) : null}
      </article>
    </aside>
  );
}
